const GradYearList = [2020, 2021, 2022, 2023, 2024, 2025, 2026];
export const GradYears = GradYearList.map((v) => ({ label: v, value: v }));
